//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getEcxTemplate=(adminclinicid=1,mediumtype,pageNo=0,pageSize=50)=>{
    return axios.get(API_URL+"clinics/"+adminclinicid+"/ecx-templates?mediumType="+mediumtype+"&pageNo="+pageNo+"&pageSize="+pageSize)
}
const getEcxTemplateById=(adminclinicid=1,templateid)=>{
    return axios.get(API_URL+"clinics/"+adminclinicid+"/ecx-templates/"+templateid)
}
const getTemplateTypes = (adminclinicid=1)=>{
    return axios.get(API_URL+"clinics/"+adminclinicid+"/ecx-templates/types")
}
const saveEcxTemplate = (adminclinicid=1,data)=>{
    return axios.post(API_URL+"clinics/"+adminclinicid+"/ecx-templates",data)
}

const deleteEcxTemplate = (adminclinicid=1,templateid) =>{
    return axios.delete(API_URL+"clinics/"+adminclinicid+"/ecx-templates/"+templateid)
}
const loadTemplates = (adminclinicid=1,data)=>{
    return axios.post(API_URL+"clinics/"+adminclinicid+"/ecx-templates/load-to-client",data)
}

//clinic email tempalte
const getEmailTemplate=(clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/email-templates")
}
const getEmailTemplateById = (clinicid,templateid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/email-templates/"+templateid)
}
const updateEmailTemplate = (clinicid,templateid,data)=>{
    return axios.put(API_URL+"clinics/"+clinicid+"/email-templates/"+templateid,data)
}

//clinic sms tempalte
const getSmsTemplate=(clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/sms-templates")
}
const getSmsTemplateById = (clinicid,templateid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/sms-templates/"+templateid)
}
const updateSmsTemplate = (clinicid,templateid,data)=>{
    return axios.put(API_URL+"clinics/"+clinicid+"/sms-templates/"+templateid,data)
}
//clinic call tempalte
const getCallTemplate=(clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/call-templates")
}
const getCallTemplateById = (clinicid,templateid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/call-templates/"+templateid)
}
const updateCallTemplate = (clinicid,templateid,data)=>{
    return axios.put(API_URL+"clinics/"+clinicid+"/call-templates/"+templateid,data)
}
const generateAudio = (clinicid,templateid) =>{
 return axios.get(API_URL+"clinics/"+clinicid+"/call-templates/"+templateid+"/audio-samples")
}

export default {
  getEcxTemplate,
  getTemplateTypes,
  getEcxTemplateById,
  saveEcxTemplate,
  deleteEcxTemplate,
  loadTemplates,
  getEmailTemplate,
  getEmailTemplateById,
  updateEmailTemplate,
  getSmsTemplate,
  getSmsTemplateById,
  updateSmsTemplate,
  getCallTemplate,
  getCallTemplateById,
  updateCallTemplate,
  generateAudio,

}